import React from 'react';
import { connect } from 'react-redux';
import { updateFilter, setFilterGroup } from 'store/actions/search';
import { defaultVideoFilters } from 'store/actions/videos';
import Checkbox from 'common/forms/checkbox/Checkbox';
import { formatNumber } from 'components/utils/helpers';

const updateVideoFilters = async (props, checked) => {
  props.updateFilter('media', 'video', checked);
  if (checked) {
    props.defaultVideoFilters();
  }
};

const MediaFilters = (props) => {
  const FEATURE_VIDEO_ENABLED = JSON.parse(process.env.FEATURE_VIDEO_ENABLED || false);

  return (
    <div className="filters--section media-filters">
      <legend>Media</legend>
      <div className="filters--checkboxes">
        <Checkbox
          checked={props.filters.media.text}
          onChange={({ target: { checked } }) => props.updateFilter('media', 'text', checked)}
        >
          News {props.filters.media.text && <span>({formatNumber(props.totals.news)})</span>}
        </Checkbox>
        <Checkbox
          checked={props.filters.media.photo}
          onChange={({ target: { checked } }) => props.updateFilter('media', 'photo', checked)}
        >
          Photos {props.filters.media.photo && <span>({formatNumber(props.totals.photos)})</span>}
        </Checkbox>
        {
          FEATURE_VIDEO_ENABLED
          && <Checkbox
            checked={props.filters.media.video}
            onChange={({ target: { checked } }) => updateVideoFilters(props, checked)}
          >
            Video {props.filters.media.video && <span>({formatNumber(props.totals.videos)})</span>}
          </Checkbox>
        }
      </div>
    </div>
  );
};

const mapStateToProps = ({ search: searchStore, user: userStore }) => ({
  filters: searchStore.filters,
  totals: searchStore.totals,
  videoBrands: userStore.user.videoBrands,
});

const mapDispatchToProps = {
  updateFilter,
  setFilterGroup,
  defaultVideoFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaFilters);
